var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82132 8.99893C7.43162 8.61008 6.80059 8.61043 6.41132 8.9997C6.02175 9.38927 6.02175 10.0209 6.41132 10.4105L10.9988 14.998C11.3894 15.3885 12.0225 15.3885 12.413 14.998L17.0006 10.4105C17.3901 10.0209 17.3901 9.38927 17.0006 8.9997C16.6113 8.61043 15.9802 8.61008 15.5906 8.99893L11.7059 12.8751L7.82132 8.99893Z",
    fill: "#D6D6D6"
  })));
}
export default SvgExpandMore;